var g = Object.defineProperty;
var c = (t, o) => g(t, "name", { value: o, configurable: !0 });
import e from "dayjs";
import { default as ct } from "dayjs";
import d from "dayjs/plugin/utc.js";
import $ from "dayjs/plugin/timezone.js";
import x from "dayjs/plugin/advancedFormat.js";
import D from "dayjs/plugin/localizedFormat.js";
import A from "dayjs/plugin/duration.js";
import b from "dayjs/plugin/isSameOrAfter.js";
import F from "dayjs/plugin/isSameOrBefore.js";
import w from "dayjs/plugin/customParseFormat.js";
import "dayjs/locale/en-gb.js";
import "dayjs/locale/cs.js";
import "dayjs/locale/sk.js";
import "dayjs/locale/pl.js";
import "dayjs/locale/hu.js";
import "dayjs/locale/de.js";
import "dayjs/locale/es.js";
import "dayjs/locale/fr.js";
import h from "sanitize-html";
import { customAlphabet as L } from "nanoid";
import { parse as S, CssTypes as y, stringify as T } from "@adobe/css-tools";
const et = [
  "in",
  "e",
  "static-api",
  "console",
  "status"
];
e.extend(d);
e.extend($);
e.extend(x);
e.extend(D);
e.extend(A);
e.extend(b);
e.extend(F);
e.extend(w);
e.extend((t, o) => {
  const r = o.prototype.format;
  o.prototype.format = function(m) {
    if (!this.isValid() || !m)
      return r.bind(this)(m);
    const i = m.replaceAll("custom-fullMonthNoYear", () => {
      var a, s;
      return `[${this.utc().toDate().toLocaleString((a = this.$locale) == null ? void 0 : a.call(this).name, {
        timeZone: (s = this.$x) == null ? void 0 : s.$timezone,
        weekday: "long",
        month: "short",
        day: "numeric"
      })}]`;
    });
    return r.bind(this)(i);
  };
});
const O = /* @__PURE__ */ c((t, o) => {
  const r = e(o).tz(e.tz.guess()).utcOffset(), m = e(o).tz(t).utcOffset();
  return r !== m;
}, "hasDeviceDifferentTimezoneOffset"), V = /* @__PURE__ */ c((t) => ["America/", "Australia/", "Pacific/Auckland", "Pacific/Honolulu", "Asia/Dubai"].some((o) => t.startsWith(o)), "hasTimezoneUSFormat"), u = "en", ot = /* @__PURE__ */ c((t = e().format(), o) => {
  const {
    format: r = "LL",
    lang: m = u,
    timezone: i = e.tz.guess() || "Europe/London",
    showTimezoneDiff: a = !1
  } = o ?? {};
  let s = (o == null ? void 0 : o.langVersion) ?? "timezone";
  const n = typeof t == "string" && e(t).isValid() ? t : null, f = typeof t == "object" && (t != null && t.start) && e(t.start).isValid() ? t.start : null, l = typeof t == "object" && (t != null && t.end) && e(t.end).isValid() ? t.end : null;
  (s === "timezone" || s === "browser") && (m === "en" ? s = V(s === "browser" ? e.tz.guess() : i) ? "US" : "GB" : s = void 0);
  const p = s ? `${m}-${s}` : m;
  if (!n && !(f && l))
    return "";
  const z = a && O(i, f ?? n) ? " (z)" : "";
  return n ? e(n).locale(p || u).tz(i).format(`${r}${z}`) : f && l && e(f).tz(i).isSame(e(l).tz(i), "day") ? `${e(f).locale(p || u).tz(i).format(r)} – ${e(l).locale(p || u).tz(i).format(`LT${z}`)}` : `${e(f).locale(p || u).tz(i).format(r)} – ${e(l).locale(p || u).tz(i).format(`${r}${z}`)}`;
}, "getFormattedDate"), rt = /* @__PURE__ */ c((t = "") => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(t).toLowerCase()), "isEmailValid"), st = /* @__PURE__ */ c((t) => String(t ?? "").normalize("NFD").replace(/[\u0300-\u036F]/g, "").replace(/[^\x00-\x7F]/g, "").toLowerCase().trim(), "normalizeString"), v = {
  ...h.defaults,
  allowedAttributes: {
    a: ["href", "target", "name", "style"],
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
    span: ["style"],
    strong: ["style"],
    em: ["style"],
    ul: ["style"]
  },
  parseStyleAttributes: !1
}, nt = /* @__PURE__ */ c((t) => h(t ?? "", v), "sanitize"), C = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_", it = /* @__PURE__ */ c((t = 12) => L(C)(t), "nanoid"), at = /* @__PURE__ */ c((t, o) => {
  try {
    const r = S(t), m = r.stylesheet.rules.map((a) => {
      if (a.type === y.rule) {
        const s = a.selectors.map((n) => n === o ? n : `${o} ${n}`);
        return { ...a, selectors: s };
      }
      if (a.type === y.media) {
        const s = a.rules.map((n) => {
          if (n.type === y.rule) {
            const f = n.selectors.map((l) => l === o ? l : `${o} ${l}`);
            return { ...n, selectors: f };
          }
          return n;
        });
        return { ...a, rules: s };
      }
      return a;
    });
    return T({
      ...r,
      stylesheet: {
        ...r.stylesheet,
        rules: m
      }
    });
  } catch (r) {
    return console.warn("Error parsing custom css", r), "";
  }
}, "prefixCustomCss");
export {
  ct as dayjs,
  ot as getFormattedDate,
  O as hasDeviceDifferentTimezoneOffset,
  rt as isEmailValid,
  it as nanoid,
  st as normalizeString,
  at as prefixCustomCss,
  et as reservedDomains,
  nt as sanitize
};
